import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import { axiosGet } from '@utils'

const ResourceCard = ({ resource }) => {
  const navigate = useNavigate()
  const handleLink = () => {
    navigate('/help-center/training-courses/view/' + resource.id)
  }
  const [imgSrc, setImgSrc] = useState('')
  useEffect(() => {
    if (!resource.image) return
    axiosGet(`s3/resource-image/${resource.image}`).then(res => setImgSrc(res.data.url))
  }, [])

  return (
    <div onClick={() => handleLink()} className='resource-card'>
      <div className='resource-image'>
        {imgSrc
          ? <img src={imgSrc}/>
          : <div className='resource-image-placeholder'><i className='fas fa-photo-video'/></div>
        }
      </div>
      <div className='resource-info'>
        <h2>{resource.name}</h2>
        <p>{resource.summary}</p>
      </div>
    </div>
  )
}
ResourceCard.propTypes = {
  resource: PropTypes.object
}

export default ResourceCard
